module.exports = __webpack_public_path__ + "static/media/Edd.a76ef9b6.png";